import bugsnag from 'bugsnag-js'
const bugsnagClient = bugsnag({
  apiKey: process.env.VUE_APP_BUG_SNAG,
  appVersion: process.env.PACKAGE_VERSION,
})

export default bugsnagClient



// WEBPACK FOOTER //
// ./src/bugsnag.js